import { Route } from '../../route.model';
import Billing from '@/views/Portal/Billing.vue';
import { getBillingIsBlocked } from '@/utils/billing';

const portalBilling = new Route('/portal/billing', 'portal-billing', Billing, {
  requiresAuth: true,
  isResponsive: true,
  // This is the iframe bridge the host's billing route embeds, so the host guard
  // already keeps it from loading. Guard it here too so the legacy origin does not
  // stay a second way into the screen (TWISM-19010) — while still letting the
  // migrated cohort through, the same way the host route does (TWISM-19180).
  customFlagValidator: () => !getBillingIsBlocked(),
  zendesk: {
    disabled: true
  }
});

export { portalBilling };
export default portalBilling;
